import { FilterButton } from 'components/FilterButton';
import { ArrowBottom, CodeEMeasurements } from 'components/Icons';
import { lastsInvoicesProps } from 'pages/ClienteArea';
import { useEffect, useMemo, useState } from 'react';
import { api } from 'services/api';
import * as S from './styles';

import 'moment/locale/pt-br';
import { MainHeader } from 'components/MainHeader';
import { BaseMain } from 'components/BaseMain';
import { Dropdown } from 'components/Dropdown';
import { DropdownLink } from 'components/DropdownLink/DropdownLink';
import SubHeader from 'components/SubHeader/SubHeader';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import ResponsiveTable from 'components/ResponsiveTable/ResponsiveTable';

const HistoryOfInvoices = () => {
  // const limitPerPage = 7;
  // const inititalLimit = limitPerPage;
  const [postsInvoices, setPostsInvoices] = useState<lastsInvoicesProps[]>([]);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState('');
  const [FilterForDateBegin, setFilterForDateBegin] = useState('');
  const [FilterFoDateEnd, setFilterForDateEnd] = useState('');
  const [moreRecent, setMoreRecent] = useState('');
  const [totalInvoice, setTotalInvoices] = useState(0);
  const history = useCustomUtilsHistory();
  const [filters, setFilters] = useState({
    status: 'Status',
    period: 'Período',
    order: 'Mais recente',
  });
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const lastFiveYears = useMemo(() => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 5 }, (_, index) => currentYear - index);
  }, []);
  const handleFilterStatus = (status: string) => {
    const capitalizeStatus = (status: string) =>
      status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    if (status !== 'ver-todos') {
      setFilters((el) => ({
        ...el,
        status: capitalizeStatus(status),
      }));
    } else {
      setFilters((el) => ({ ...el, status: 'Status' }));
    }
    switch (status) {
      case 'aberta':
        setFilterStatus('aberta');
        break;
      case 'paga':
        setFilterStatus('paga');
        break;
      case 'vencida':
        setFilterStatus('vencida');
        break;
      default:
        setFilterStatus('');
    }
  };

  const handleFilterForDate = (date: string) => {
    if (date !== 'ver-todos') {
      setFilters((el) => ({ ...el, period: date }));
    } else {
      setFilters((el) => ({ ...el, period: 'Período' }));
    }
    if (date === 'ver-todos') {
      setFilterForDateBegin('');
      setFilterForDateEnd('');
    } else {
      // Handle any year dynamically
      const year = parseInt(date);
      if (!isNaN(year)) {
        setFilterForDateBegin(`${year}-01-01`);
        setFilterForDateEnd(`${year}-12-31`);
      }
    }
  };

  const showMoreInvoices = () => {
    setPostsPerPage((postsPerPage) => postsPerPage + 10);
  };
  const handleMoreRecent = (status: string) => {
    if (status !== 'mais recente') {
      setFilters((el) => ({ ...el, order: 'Mais antigo' }));
    } else {
      setFilters((el) => ({ ...el, order: 'Mais recente' }));
    }
    status === 'mais recente' ? setMoreRecent('desc') : setMoreRecent('asc');
  };

  const disableButtonCarregarMais = postsPerPage >= totalInvoice;

  useEffect(() => {
    const fetchDataBillings = async () => {
      setIsLoading(true);
      try {
        const { data } = await api.get(
          `client/billings?page=1&limit=${postsPerPage}&sort=${moreRecent}&status=${filterStatus}&dueDateBegin=${FilterForDateBegin}&dueDateEnd=${FilterFoDateEnd}`,
          {
            headers: {
              'content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              idToken,
            },
          },
        );
        // setPostsInvoices((lastsInvoicesProps) => [
        //   ...previousInvoices,
        //   ...data.data,
        // ]);

        setPostsInvoices(data.data);
        setTotalInvoices(data.pagination.total);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    fetchDataBillings();
  }, [
    filterStatus,
    moreRecent,
    accessToken,
    idToken,
    FilterForDateBegin,
    FilterFoDateEnd,
    postsPerPage,
    // page,
  ]);

  return (
    <>
      <MainHeader />
      <SubHeader
        title="Histórico de faturas"
        onReturn={() => history.push('/ClientArea')}
      />
      <BaseMain hideHeader>
        <S.FilterButtonWrapper>
          <div>
            <Dropdown
              title={false}
              width="20rem"
              position="10rem"
              IsCloseDropdown
              disabled={isLoading}
              element={
                <FilterButton text={filters.order} size="15.1rem">
                  <ArrowBottom />
                </FilterButton>
              }
            >
              <DropdownLink
                arrowRight={filters.order === 'Mais recente'}
                newTab={false}
                handleClick={() => handleMoreRecent('mais recente')}
              >
                Mais recentes
              </DropdownLink>
              <DropdownLink
                arrowRight={filters.order === 'Mais antigo'}
                newTab={false}
                handleClick={() => handleMoreRecent('mais antigo')}
              >
                Mais antigo
              </DropdownLink>
            </Dropdown>
            <Dropdown
              title={false}
              width="15rem"
              IsCloseDropdown
              disabled={isLoading}
              element={
                <FilterButton text={filters.status} size="auto">
                  <ArrowBottom />
                </FilterButton>
              }
            >
              <DropdownLink
                arrowRight={filters.status === 'Status'}
                newTab={false}
                handleClick={() => handleFilterStatus('ver-todos')}
              >
                Ver Todos
              </DropdownLink>
              <DropdownLink
                arrowRight={filters.status === 'Aberta'}
                newTab={false}
                handleClick={() => handleFilterStatus('aberta')}
              >
                Aberta
              </DropdownLink>
              <DropdownLink
                arrowRight={filters.status === 'Paga'}
                newTab={false}
                handleClick={() => handleFilterStatus('paga')}
              >
                Paga
              </DropdownLink>
              <DropdownLink
                arrowRight={filters.status === 'Vencida'}
                newTab={false}
                handleClick={() => handleFilterStatus('vencida')}
              >
                Vencida
              </DropdownLink>
            </Dropdown>
            <Dropdown
              title={false}
              width="15rem"
              IsCloseDropdown
              disabled={isLoading}
              element={
                <FilterButton text={filters.period} size="11.4rem">
                  <ArrowBottom />
                </FilterButton>
              }
              position="10rem"
            >
              <DropdownLink
                arrowRight={filters.period === 'Período'}
                newTab={false}
                handleClick={() => handleFilterForDate('ver-todos')}
              >
                Ver Todos
              </DropdownLink>
              {lastFiveYears.map((year) => (
                <DropdownLink
                  key={year}
                  arrowRight={filters.period === year.toString()}
                  newTab={false}
                  handleClick={() => handleFilterForDate(year.toString())}
                >
                  {year}
                </DropdownLink>
              ))}
            </Dropdown>
          </div>
          {totalInvoice > 0 && (
            <span>
              {`
            ${totalInvoice}
            ${
              postsInvoices.length > 1
                ? 'faturas encontradas'
                : 'fatura encontrada'
            }`}
            </span>
          )}
        </S.FilterButtonWrapper>
        {totalInvoice > 0 || isLoading ? (
          <ResponsiveTable
            value={postsInvoices}
            loadingTable={isLoading}
            disableButtonMore={disableButtonCarregarMais}
            moreValues={showMoreInvoices}
            showButtonMore={totalInvoice > 10}
          />
        ) : (
          !isLoading && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                backgroundColor: 'white',
                padding: '64px 24px',
                justifyContent: 'center',
                gap: '16px',
                flexWrap: 'wrap',
                borderRadius: '12px',
              }}
            >
              <CodeEMeasurements />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-evenly',
                }}
              >
                <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
                  Nenhuma fatura encontrada
                </span>
                <span style={{ fontSize: '16px', maxWidth: '350px' }}>
                  Altere os parâmetros dos filtros para encontrar a fatura
                  desejada.
                </span>
              </div>
            </div>
          )
        )}
      </BaseMain>
    </>
  );
};

export default HistoryOfInvoices;
